export class Winery {
    id: number;
    name: string;
	active: boolean;
    sort_order: number;

    region_id: number;
    production_rate: string;
    ha_wijngaard: string;
    certification: boolean;
    address: string;
    link_website: string;
    link_youtube: string;

    alias: string;
	
	description_nl: string;
	
	description_en: string;
	
	description_fr: string;
	
	description_de: string;
	
	created_at: string;
    updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/winery.ts